import type { ScrollWorldConfig } from './scroll-world-types'

/** Public asset root: drop Higgsfield-encoded clips here when ready. */
const ASSET = '/nin/scroll-world'

/**
 * NIN sanctuary fly-through: six diorama beats from temple to open source.
 * Posters from Higgsfield stills; clips wired when encoded mp4s exist in /vid.
 */
const clip = (id: string) => `${ASSET}/vid/${id}.mp4`

export const NIN_SCROLL_WORLD_CONFIG: ScrollWorldConfig = {
  diveScroll: 1.35,
  connScroll: 0.85,
  hint: 'scroll to fly in',
  nav: false,
  atmosphere: true,
  crossfade: 0.1,
  sections: [
    {
      id: 'sanctuary',
      label: 'Sanctuary',
      still: `${ASSET}/sanctuary.png`,
      clip: clip('sanctuary'),
      // baby: Longer first beat so "Your data stays yours" can be read while scrolling
      scroll: 2.9,
      linger: 0.55,
      accent: '#21728d',
      eyebrow: 'A sanctuary for users',
      title: 'Your data stays yours.',
      body: 'Fly into the NIN temple: a quiet refuge where inference and files remain on your devices by default.',
      tags: ['On device', 'Open source', 'Private'],
    },
    {
      id: 'ninx',
      label: 'NINX',
      still: `${ASSET}/ninx.png`,
      clip: clip('ninx'),
      // baby: Match sanctuary: longer dwell so copy can be read while scrolling
      scroll: 2.6,
      linger: 0.52,
      accent: '#1a5f75',
      eyebrow: 'Private desktop AI',
      title: 'NINX on your desk.',
      body: 'Local-first agents for Mac and PC: chat, voice, tools, and automations without sending your life to the cloud.',
      tags: ['Desktop', 'Local models', 'Agents'],
    },
    {
      id: 'nink',
      label: 'NINK',
      still: `${ASSET}/nink.png`,
      clip: clip('nink'),
      scroll: 2.5,
      linger: 0.5,
      accent: '#3d8fa8',
      eyebrow: 'Tray voice writing',
      title: 'Speak into any app.',
      body: 'Ink Flow from the menu bar. Whisper transcription and rewrite that never leaves your machine.',
      tags: ['Voice', 'Menu bar', 'Whisper'],
    },
    {
      id: 'ningenie',
      label: 'Ningenie',
      still: `${ASSET}/ningenie.png`,
      clip: clip('ningenie'),
      scroll: 2.55,
      linger: 0.5,
      accent: '#4aa3bc',
      eyebrow: 'Mobile agents',
      title: "Don't ask, just task.",
      body: 'A digital assistant that executes across your phone apps: under your approval, on your terms.',
      tags: ['Mobile', 'Automation', 'Approval'],
    },
    {
      id: 'privacy',
      label: 'Privacy',
      still: `${ASSET}/privacy.png`,
      clip: clip('privacy'),
      scroll: 2.6,
      linger: 0.52,
      accent: '#186678',
      eyebrow: 'Data sanctuary',
      title: 'Encrypted at the edge.',
      body: 'Hover the vault in the world below. NIN products keep secrets local unless you choose otherwise.',
      tags: ['E2E', 'Local vault', 'Zero trust'],
    },
    {
      id: 'community',
      label: 'Start',
      still: `${ASSET}/community.png`,
      clip: clip('community'),
      scroll: 3.0,
      linger: 0.58,
      accent: '#21728d',
      eyebrow: 'Open source guardians',
      title: 'Join the sanctuary.',
      body: 'Three agents, one mission: protect users and their data with software you can inspect and trust.',
      tags: ['GitHub', 'Community', 'Free to start'],
    },
  ],
  connectors: [
    `${ASSET}/vid/conn1.mp4`,
    `${ASSET}/vid/conn2.mp4`,
    `${ASSET}/vid/conn3.mp4`,
    `${ASSET}/vid/conn4.mp4`,
    `${ASSET}/vid/conn5.mp4`,
  ],
}